export default "__VITE_ASSET__DuCF2X_v__"